import { Link } from 'react-router-dom';

export default function OurExperiences() {
  const experienceGallery = [
  {
    id: 'great-west-africa-rendezvous',
    title: 'The Great West Africa Rendezvous',
    tagline: 'Cultural Convergence Experience',
    // category: 'Cultural IP',
    description: 'Immersive cultural journeys across West Africa connecting diaspora communities through music, food, art, and heritage.',
    images: [
      {
        url: '/assets/hero/cultural.jpeg',
        caption: 'Cultural festival opening ceremony',
        aspect: 'vertical',
        photographer: 'West Africa Cultural Festival'
      },
      {
        url: '/assets/experience/Drum-Circle.jpeg',
        caption: 'Traditional music performance',
        aspect: 'horizontal',
        photographer: 'African Drum Circle'
      },
      {
        url: '/assets/hero/europe.jpeg',
        caption: 'Culinary masterclass session',
        aspect: 'vertical',
        photographer: 'West African Cuisine'
      },
      {
        url: '/assets/experience/Textile-Market.jpeg',
        caption: 'Artisan market showcase',
        aspect: 'horizontal',
        photographer: 'African Textile Market'
      },
      {
        url: '/assets/experience/Community-Workshop.jpeg',
        caption: 'Community engagement workshop',
        aspect: 'vertical',
        photographer: 'Community Workshop'
      },
      {
        url: '/assets/experience/Historical-Architecture.jpeg',
        caption: 'Heritage site exploration',
        aspect: 'horizontal',
        photographer: 'Historical Architecture'
      }
    ],
    highlights: [
      'Annual multi-destination cultural festival',
      '8+ West African countries',
      '5,000+ annual participants',
      'Diaspora reconnection focus',
      'Local artisan partnerships',
      'Music, food, art, heritage integration'
    ],
    color: 'from-amber-500 to-orange-600',
    season: 'Annual | November-December',
    regions: ['Ghana', 'Nigeria', 'Senegal', 'Ivory Coast', 'Gambia', 'Benin', 'Togo', 'Sierra Leone'],
    stats: [
      { label: 'Countries', value: '8+' },
      { label: 'Annual Scale', value: '5,000+' },
      { label: 'IP Ownership', value: '100% MGL' },
      { label: 'Duration', value: '7-10 days' }
    ],
    licensingModel: 'Regional Operator Licensing',
    targetAudience: ['Diaspora Communities', 'Cultural Enthusiasts', 'International Travelers', 'Heritage Seekers'],
    keyFeatures: [
      'Multi-city cultural programming',
      'Local community integration',
      'Sustainable tourism focus',
      'Digital & physical experiences'
    ]
  },
  {
    id: 'boundless-europe-experience',
    title: 'Boundless Europe Experience',
    tagline: 'Multi-Country European Journey',
    // category: 'Group Travel IP',
    description: 'Curated European itineraries designed for group travel, corporate retreats, and diaspora heritage exploration.',
    images: [
      {
        url: '/assets/experience/Swiss-Alps.jpeg',
        caption: 'Alpine mountain retreat',
        aspect: 'vertical',
        photographer: 'Swiss Alps'
      },
      {
        url: '/assets/experience/European-Cityscape.jpeg',
        caption: 'Historic city walking tour',
        aspect: 'horizontal',
        photographer: 'European Cityscape'
      },
      {
        url: '/assets/experience/Vineyard-Tour.jpeg',
        caption: 'Wine tasting experience',
        aspect: 'vertical',
        photographer: 'Vineyard Tour'
      },
      {
        url: '/assets/experience/Mediterranean-Coast.jpeg',
        caption: 'Coastal heritage exploration',
        aspect: 'horizontal',
        photographer: 'Mediterranean Coast'
      },
      {
        url: '/assets/experience/Alpine-Village.jpeg',
        caption: 'Mountain village immersion',
        aspect: 'vertical',
        photographer: 'Alpine Village'
      },
      {
        url: '/assets/experience/Travel-Experience.jpeg',
        caption: 'Cultural workshop participation',
        aspect: 'horizontal',
        photographer: 'Group Travel Experience'
      }
    ],
    highlights: [
      '4-6 European countries per journey',
      '10-14 day curated itineraries',
      'Group sizes: 20-40 participants',
      'Corporate retreat focus',
      'Heritage and culinary focus',
      'Luxury accommodation options'
    ],
    color: 'from-blue-500 to-indigo-600',
    season: 'Year-round | Custom Departures',
    regions: ['France', 'Italy', 'Spain', 'Portugal', 'Switzerland', 'Austria', 'Germany', 'Netherlands'],
    stats: [
      { label: 'Countries', value: '4-6' },
      { label: 'Duration', value: '10-14 days' },
      { label: 'Group Size', value: '20-40' },
      { label: 'Customization', value: 'Flexible' }
    ],
    licensingModel: 'Operator Franchise Model',
    targetAudience: ['Corporate Groups', 'Diaspora Organizations', 'Affinity Groups', 'Luxury Travelers'],
    keyFeatures: [
      'Cross-border itineraries',
      'Local expert guides',
      'Premium accommodations',
      'Cultural immersion activities'
    ]
  },
  // {
  //   id: 'corporate-retreats',
  //   title: 'Corporate & Leadership Retreats',
  //   tagline: 'Custom Organizational Experiences',
  //   category: 'Corporate IP',
  //   description: 'Tailored travel experiences for team building, leadership development, and organizational culture enhancement.',
  //   images: [
  //     {
  //       url: '/assets/experience/Retreat-Venue.jpeg',
  //       caption: 'Executive retreat setting',
  //       aspect: 'horizontal',
  //       photographer: 'Corporate Retreat Venue'
  //     },
  //     {
  //       url: '/assets/experience/Team-Collaboration.jpeg',
  //       caption: 'Team building activities',
  //       aspect: 'vertical',
  //       photographer: 'Team Collaboration'
  //     },
  //     {
  //       url: '/assets/experience/Business-Meeting.jpeg',
  //       caption: 'Strategy session venue',
  //       aspect: 'horizontal',
  //       photographer: 'Business Meeting'
  //     },
  //     {
  //       url: '/assets/experience/Yoga-Retreat.jpeg',
  //       caption: 'Wellness and mindfulness',
  //       aspect: 'vertical',
  //       photographer: 'Yoga Retreat'
  //     },
  //     {
  //       url: '/assets/experience/Dining-Experience.jpeg',
  //       caption: 'Networking dinners',
  //       aspect: 'horizontal',
  //       photographer: 'Fine Dining Experience'
  //     },
  //     {
  //       url: '/assets/experience/Outdoor-Adventure.jpeg',
  //       caption: 'Adventure team challenges',
  //       aspect: 'vertical',
  //       photographer: 'Outdoor Adventure'
  //     }
  //   ],
  //   highlights: [
  //     'Fully customized itineraries',
  //     'Leadership development integration',
  //     'Team cohesion focus',
  //     'Wellness and mindfulness',
  //     'Strategic venue selection',
  //     'Measurable ROI metrics'
  //   ],
  //   color: 'from-emerald-500 to-teal-600',
  //   season: 'Year-round | Custom Scheduling',
  //   regions: ['Global Destinations', 'Bespoke Locations', 'Remote Retreats', 'Urban Centers'],
  //   stats: [
  //     { label: 'Group Size', value: '10-100+' },
  //     { label: 'Duration', value: '3-7 days' },
  //     { label: 'ROI Tracking', value: 'Included' },
  //     { label: 'Customization', value: '100%' }
  //   ],
  //   licensingModel: 'White-label & Custom Development',
  //   targetAudience: ['Corporate Leadership', 'Management Teams', 'Sales Organizations', 'Startup Teams'],
  //   keyFeatures: [
  //     'Bespoke programming',
  //     'Professional facilitation',
  //     'Technology integration',
  //     'Performance measurement'
  //   ]
  // },
  // {
  //   id: 'diaspora-heritage',
  //   title: 'Diaspora Heritage Journeys',
  //   tagline: 'Roots & Reconnection Experiences',
  //   category: 'Heritage IP',
  //   description: 'Meaningful heritage travel connecting diaspora communities with ancestral homelands through curated cultural immersion.',
  //   images: [
  //     {
  //       url: '/assets/experience/Heritage-Connection.jpeg',
  //       caption: 'Ancestral village visit',
  //       aspect: 'vertical',
  //       photographer: 'Heritage Connection'
  //     },
  //     {
  //       url: '/assets/experience/Family-History.jpeg',
  //       caption: 'Historical documentation',
  //       aspect: 'horizontal',
  //       photographer: 'Family History'
  //     },
  //     {
  //       url: '/assets/experience/Traditional-Ceremony.jpeg',
  //       caption: 'Cultural ceremony participation',
  //       aspect: 'vertical',
  //       photographer: 'Traditional Ceremony'
  //     },
  //     {
  //       url: '/assets/experience/Family-Research.jpeg',
  //       caption: 'Genealogy research session',
  //       aspect: 'horizontal',
  //       photographer: 'Family Research'
  //     },
  //     {
  //       url: '/assets/experience/Oral-History.jpeg',
  //       caption: 'Community storytelling',
  //       aspect: 'vertical',
  //       photographer: 'Oral History'
  //     },
  //     {
  //       url: '/assets/experience/Historical-Sites.jpeg',
  //       caption: 'Heritage site exploration',
  //       aspect: 'horizontal',
  //       photographer: 'Historical Sites'
  //     }
  //   ],
  //   highlights: [
  //     'Ancestral village connections',
  //     'Genealogy research support',
  //     'Cultural immersion depth',
  //     'Multigenerational travel',
  //     'Community-led experiences',
  //     'Legacy documentation'
  //   ],
  //   color: 'from-purple-500 to-pink-600',
  //   season: 'Custom | Seasonal Availability',
  //   regions: ['Africa', 'Caribbean', 'Asia', 'Europe', 'Americas'],
  //   stats: [
  //     { label: 'Generations', value: '2-3' },
  //     { label: 'Duration', value: '7-14 days' },
  //     { label: 'Research Depth', value: 'Comprehensive' },
  //     { label: 'Customization', value: 'High' }
  //   ],
  //   licensingModel: 'Specialist Operator Partnerships',
  //   targetAudience: ['Diaspora Families', 'Heritage Seekers', 'Cultural Organizations', 'Academic Groups'],
  //   keyFeatures: [
  //     'Genealogy integration',
  //     'Local community hosting',
  //     'Documentation support',
  //     'Legacy creation focus'
  //   ]
  // }
];

  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-gradient-to-r from-primary/30 to-secondary/30"></div>
        </div>
        <div className="section-container relative">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 mb-6">
              <div className="w-3 h-3 bg-primary rounded-full animate-pulse"></div>
              <span className="text-sm font-medium text-primary uppercase tracking-wider">
                Experience IP Gallery
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
              Visual Journey Through
              <span className="block text-primary mt-2">Our Experience IP</span>
            </h1>
            <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
              Explore our licensable travel IP through visual storytelling. Each format represents scalable experience architecture, not retail travel products.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="font-medium">B2B Licensing Focus</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="font-medium">IP-First Design</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="font-medium">Operator Execution</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <div className="section-container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Experience IP Portfolio
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Visual representations of our scalable experience formats, designed for licensing by certified travel operators.
          </p>
        </div>

        {experienceGallery.map((experience, expIndex) => (
          <div key={experience.id} className="mb-24 scroll-mt-20" id={experience.id}>
            {/* Experience Header */}
            <div className="mb-12">
              <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
                <div>
                  
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                    {experience.title}
                  </h3>
                  <p className="text-xl text-gray-600 mb-4">{experience.tagline}</p>
                  <p className="text-gray-700 max-w-3xl">{experience.description}</p>
                </div>
                <div className="flex-shrink-0">
                  <Link
                    to={`/partners-sponsors`}
                    className="inline-flex items-center text-primary font-medium hover:text-primary-dark"
                  >
                    Partners and Sponsors
                    <svg className="w-5 h-5 ml-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
              </div>

              {/* Stats & Highlights */}
              <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="text-2xl font-bold text-gray-900 mb-1">{experience.highlights[0].split('|')[0]}</div>
                  <div className="text-sm text-gray-500">{experience.highlights[0].split('|')[1] || 'Feature'}</div>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="text-2xl font-bold text-gray-900 mb-1">{experience.highlights[1]}</div>
                  <div className="text-sm text-gray-500">Key Highlight</div>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="text-2xl font-bold text-gray-900 mb-1">{experience.season.split('|')[0]}</div>
                  <div className="text-sm text-gray-500">Season</div>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="text-2xl font-bold text-gray-900 mb-1">{experience.regions.length}+</div>
                  <div className="text-sm text-gray-500">Regions</div>
                </div>
              </div>
            </div>

            {/* Image Gallery Grid */}
            <div className="mb-12">
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {experience.images.map((image, imgIndex) => (
                  <div
                    key={imgIndex}
                    className={`relative rounded-xl overflow-hidden group cursor-pointer ${
                      image.aspect === 'vertical' ? 'row-span-2 h-64 md:h-80' : 'col-span-2 h-32 md:h-40'
                    }`}
                  >
                    <div 
                      className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                      style={{ backgroundImage: `url('${image.url}')` }}
                    >
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                    </div>
                    
                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                        <p className="text-sm font-medium">{image.caption}</p>
                        <p className="text-xs opacity-75">Click to view larger</p>
                      </div>
                    </div>
                    
                    {/* Category Badge */}
                    <div className="absolute top-3 left-3">
                      <span className="inline-block px-2 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-gray-900">
                        {experience.category}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Experience Details */}
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <div className="bg-white rounded-xl shadow-lg p-8">
                  <h4 className="text-lg font-bold text-gray-900 mb-4">Experience Highlights</h4>
                  <div className="grid md:grid-cols-2 gap-4">
                    {experience.highlights.map((highlight, idx) => (
                      <div key={idx} className="flex items-start">
                        <div className={`w-2 h-2 bg-gradient-to-r ${experience.color} rounded-full mt-2 mr-3`}></div>
                        <span className="text-gray-700">{highlight}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-900 text-white rounded-xl p-8">
                  <h4 className="text-lg font-bold mb-4">Licensing Information</h4>
                  <ul className="space-y-3 mb-6">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span>Available for operator licensing</span>
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span>Complete IP framework included</span>
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span>Marketing and operational support</span>
                    </li>
                  </ul>
                  <Link
                    to="/contact"
                    className="inline-flex items-center justify-center w-full bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-lg transition-colors"
                  >
                    Inquire About Licensing
                  </Link>
                </div>
              </div>
            </div>

            {/* Divider between experiences */}
            {expIndex < experienceGallery.length - 1 && (
              <div className="mt-16 pt-8 border-t border-gray-200">
                <div className="text-center">
                  <div className="inline-flex items-center text-gray-400">
                    <div className="w-24 h-px bg-gray-300"></div>
                    <span className="mx-4">Next Experience</span>
                    <div className="w-24 h-px bg-gray-300"></div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <section className="bg-gradient-to-r from-primary to-secondary text-white py-20">
        <div className="section-container text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to License Visual Experience IP?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
            Our visual experience formats are designed for impactful storytelling and scalable execution through certified operators.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-white text-gray-900 font-medium py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors"
            >
              Start Licensing Conversation
            </Link>
            <Link
              to="/what-we-do"
              className="border-2 border-white text-white font-medium py-3 px-8 rounded-lg hover:bg-white hover:text-gray-900 transition-colors"
            >
              View IP Details
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}